import { en } from "./en/index.js";
import { hi } from "./hi/index.js";
import { kn } from "./kn/index.js";
/** Every language's strings. A new language is one folder and one line here, plus its value in `Lang`. */
const STRINGS = { en, hi, kn };
/** The locale each language formats dates and times with. Digits stay Western, as UPI apps and bank SMS show them. */
export const LOCALE = { en: "en-IN", hi: "hi-IN", kn: "kn-IN" };
const PLACEHOLDER = /\{(\w+)\}/g;
const ONE = "one";
/** The string for `key` in `lang`, with `{name}` placeholders filled from `params` (left as is when not given). */
export function t(lang, key, params = {}) {
    return STRINGS[lang][key].replace(PLACEHOLDER, (whole, name) => name in params ? String(params[name]) : whole);
}
/** The `.one` or `.other` form of `key` that the language's own plural rules pick for `count`. */
export const pluralKey = (lang, key, count) => new Intl.PluralRules(LOCALE[lang]).select(count) === ONE ? `${key}.one` : `${key}.other`;
/** A counted string, in the form the language's own plural rules pick for `count`; `{count}` is filled in. */
export function plural(lang, key, count, params = {}) {
    return t(lang, pluralKey(lang, key, count), { ...params, count });
}
/** "7:03 pm" in the owner's locale. */
export const timeText = (lang, at) => at.toLocaleTimeString(LOCALE[lang], { hour: "numeric", minute: "2-digit" });
/** "28/10/2026" in the owner's locale. */
export const dateText = (lang, at) => at.toLocaleDateString(LOCALE[lang]);
/** A question the other side's agent asked, in this owner's language. */
export const questionText = (lang, key) => t(lang, `question.${key}`);
//# sourceMappingURL=t.js.map